var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Jams"},[_c('h2',{attrs:{"id":"teman"}},[_vm._v("Genomförda jams")]),_vm._v(" "),_c('div',{staticClass:"section"},_vm._l((_vm.jams),function(jam){return _c('div',[_c('jam',{attrs:{"jam":jam}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3d4c4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Jams.vue
// module id = null
// module chunks = 